<template>
    <div>

        <v-dialog v-model="isActive" width="500" scrollable transition="dialog-top-transition">
            <v-card class="rounded-0">
                <v-card flat>
                    <v-app-bar class="rounded-0" height="60" color="white" flat>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon @click="confirmAndClose(false)">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                            </template>
                            <span>Cerrar</span>
                        </v-tooltip>
                        <v-toolbar-title class="font-weight-bold primary--text">
                            QUIERO QUE ME LLAMEN
                        </v-toolbar-title>
                    </v-app-bar>
                </v-card>
                <v-card class="rounded-0 elevation-0">
                    <ValidationObserver ref="obs" v-slot="{ invalid }">
                        <v-form name="formLlamame" @submit.prevent="llamame">
                            <v-row class="ma-1 px-3">
                                <v-col cols="12" md="12"
                                    class="d-flex flex-row justify-start font-weight-bold primary--text">
                                    NÚMERO DE TELÉFONO
                                </v-col>
                                <v-col cols="5" md="5">
                                    <ValidationProvider rules="required|minmax:2,4|numeric" v-slot="v">
                                        <v-text-field v-model="carac" type="number" hide-spin-buttons prefix="0-"
                                            label="Prefijo sin 0" append-icon="mdi-pencil-outline"
                                            @keydown="preventArrowKeys" outlined
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="7" md="7">
                                    <ValidationProvider :rules="getRules" v-slot="v">
                                        <v-text-field v-model="nrotelefono" type="number" hide-spin-buttons
                                            label="Nro. Teléfono" append-icon="mdi-pencil-outline"
                                            @keydown="preventArrowKeys" outlined @blur="formatoYValidacion"
                                            :error-messages="v.errors[0]"></v-text-field>
                                    </ValidationProvider>
                                </v-col>
                                <v-col cols="12" md="12"
                                    class="d-flex flex-row justify-start font-weight-bold primary--text py-0">
                                    HORARIO</v-col>
                                <v-col cols="12" md="12" class="d-flex flex-row justify-center pa-0 ma-0">
                                    <v-row class="ma-0 pa-2">
                                        <v-col v-for="button in buttons" :key="button.value" cols="6" class="pa-1">
                                            <v-btn flat :value="button.value" :outlined="selectedBtn !== button.value"
                                                elevation="0" block class="py-5 white--text font-weight-bold"
                                                style="border: 2px solid;" color="primary"
                                                @click="selectButton(button.value)">
                                                {{ button.text }}
                                            </v-btn>
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col md="12" cols="12" class="d-flex flex-column align-center">
                                    <v-btn type="llamame" elevation='0' block :disabled="invalid || !horarioSelect"
                                        class="py-5" color="primary">
                                        ACEPTAR
                                    </v-btn>
                                    <v-btn @click="confirmAndClose(false)" block class="py-5 mt-1" width="150px"
                                        outlined color="secondary">
                                        CERRAR
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </ValidationObserver>
                </v-card>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { mapActions, mapGetters } from 'vuex'

export default {
    mounted() {
        this.objLlamar.nroafi = this.nroafi
        this.objLlamar.nombreApellido = this.nombreApellido;
        this.objLlamar.tipoDeuda = this.user.tienedeuda
        this.objLlamar.emailAfi = this.emailAfiliado
        /*         if (this.telefonoPrinc && this.telefonoPrinc.telefono !== "") {
                    this.tel = `${this.telefonoPrinc.carac}${this.telefonoPrinc.telefono}`
                } else if (this.telefono[0] && this.telefono[0].telefono) {
                    this.tel = `${this.telefono[0].carac}${this.telefono[0].telefono}`
                } else {
                    this.tel = ""
                } */
    },
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    data() {
        return {
            isActive: false,

            objLlamar: {
                nroafi: '',
                telefonoAfi: '',
                emailDistrito: '',
                emailAfi: '',
                rango: '',
                desrango: '',
                tipoComunicacion: 'deuda',
                nombreApellido: ''
            },


            selectedBtn: '',
            carac: '',
            nrotelefono: '',
            input: '',
            nro_afi: '',
            buttons: [
                { value: 1, text: 'de 8 a 12hs.' },
                { value: 2, text: 'de 12 a 16hs.' }
            ],
        }
    },

    computed: {
        ...mapGetters('auth', ['isAuthenticated', 'nroafi', 'user', 'emailAuth', 'email', 'emaildistrito']),
        ...mapGetters(['emailPrinc']),
        ...mapGetters('common', ['datosDistrito']),
        getRules() {
            return { required: true, numeric: true, validPhone: { caracteristica: this.carac } }
        },

        /*         telefonoCompleto() {
                    return `${this.telefonoPrinc.carac}${this.telefonoPrinc.telefono}`
                }, */
        horarioSelect() {
            return ((this.selectedBtn !== '') && (this.selectedBtn !== undefined))
        },
        camposCompletos() {
            return (this.carac.length !== 0 && this.nrotelefono.length !== 0)
        },
        carnumero() {
            return `${this.carac}${this.nrotelefono}`
        },
        nombreApellido() {
            return `${this.user.nombres} ${this.user.apellido}`

        },
        emailAfiliado() {
            if (this.emailPrinc.email !== '') return this.emailPrinc.email
            else if (this.user.email !== '') return this.user.email
            else return this.emailAuth
        }

    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions('mediosDeContacto', ['envioMailDistrito']),
        //...mapActions('mediosDeContacto', ['envioMailDistrito']),
        //metodos de accion de dialogo
        cerrarDialogo() {

            this.isActive = false

        },
        llamame() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    /*                     const data = {
                                            nroafi: this.nroafi,
                                            telefonoAfi: this.carnumero,
                                            emailDistrito: 'sistemas@cajapsipba.org.ar',
                                            emailAfi: 'sistemas@cajapsipba.org.ar',
                                            rango: this.selectedBtn,
                                            desrango: this.buttons[this.selectedBtn].text,
                                            tipoComunicacion: "deuda",
                                            nombreApellido: this.nombreApellido
                                        } */
                    this.envioMailDistrito(this.objLlamar)
                    this.confirmAndClose(true)
                }
                else this.confirmAndClose(false)
            })
        },

        abrirDialogo() {
            this.isActive = true;
            return new Promise(resolve => {
                this.callback = resolve;
            })
        },

        confirmAndClose(result) {
            if (this.callback) {
                this.callback(result);
                this.callback = null;
            }
            this.isActive = false
        },
        selectButton(value) {
            if (value) {
                this.selectedBtn = value;
                const selectedButton = this.buttons.find(button => button.value === value);
                if (selectedButton) {
                    this.objLlamar.rango = selectedButton.value;
                    this.objLlamar.emailDistrito = this.emaildistrito
                    this.objLlamar.desrango = selectedButton.text;
                }
            } else {
                this.selectedBtn = 0;
                this.objLlamar.emailDistrito = ""
                this.objLlamar.rango = '';
                this.objLlamar.desrango = '';
            }
        },

        formatoYValidacion() {
            const car = this.carac.length
            const num = this.nrotelefono.length
            if ((car + num !== 10) && (this.camposCompletos)) {
                this.showSnack({
                    message: 'La totalidad del número telefonico (prefijo y número) debe ser igual a 10 caractéres.',
                    type: '400'
                })
                this.objLlamar.telefonoAfi = ''
            } else if (this.camposCompletos) {
                this.carac = this.carac.replace(/\D/g, '');
                this.nrotelefono = this.nrotelefono.replace(/\D/g, '');
                this.objLlamar.telefonoAfi = `${this.carac}${this.nrotelefono}`
            }
        },
        /*         formatInput(value) {
                    // Eliminar cualquier cosa que no sea dígitos
                    const formattedValue = value.replace(/\D/g, '');
        
                    // Insertar el guion en la posición adecuada
                    if (this.formattedValue.length > 4) {
                        this.formattedValue = this.formattedValue.slice(0, 4) + '-' + this.formattedValue.slice(4, 8);
                    }
                    this.input = this.formattedValue;
                }, */
        //Bloqueo de teclas
        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
    },
    props: ['titulo']

}

</script>